const SWITCH_ORGANISATION = (org_id) =>
  `/api/access/auth/organisation/${org_id}/switch/`;

export { SWITCH_ORGANISATION };
